import React from 'react';
import '../assets/styles/Footer.css'

const Footer = ()=>(
    <footer className="footer">
        <p className="footer-p">Copyright &copy; 2019 DeallerAlly - All rights reserved.</p>
    </footer>
);

export default Footer;